export default __webpack_public_path__ + "static/media/automovelSmall.f221c659.png";